import EmblaCarousel from 'components/carousel2025/EmblaCarousel';
import styles from './FullscreenImageGallery.module.css';
import useEmblaCarousel from 'embla-carousel-react';
import CarouselButtons from 'components/carousel2025/CarouselButtons';
import { ASSET_PREFIX } from 'utils/constants';
import { useEffect } from 'react';
interface Props {
  images: { src: string, alt?: string }[];
  initialIndex: number | undefined;
  onCloseClick: () => void;
}
/** A full screen image gallery. Images will be displayed centered within the screen (rather than clipped).
 * 
 * This uses EmblaCarousel behind the scenes, so doesn't do anything special with preloading or lazy
 * rendering of images
 * 
 * We should avoid overcomplicating this gallery in a way that makes it render absolutely anything */
const FullScreenImageGallery = (props: Props) => {
  const emblaCarouselInfo = useEmblaCarousel({ loop: false, duration: 10, inViewThreshold: 0.1 },);
  useEffect(() => {
    if (props.initialIndex != undefined) {
      emblaCarouselInfo[1]?.scrollTo(props.initialIndex, true);
    }
  }, [props.initialIndex, emblaCarouselInfo?.[1]]);
  return (
    props.initialIndex != undefined ?
    <div className={styles.dimmedBackground }>
      <EmblaCarousel
        className={styles.carousel}
        emblaCarouselInfo={emblaCarouselInfo}
        items={props.images.map((x, index) =>
          <img key={index} src={x.src} alt={x.alt} />
        )}
        stretchItemHeight
      >
        <CarouselButtons
          changeSelectedIndex={x => x < 0 ? emblaCarouselInfo[1]?.scrollPrev() : emblaCarouselInfo[1]?.scrollNext()}
          dropShadow
          />
          <button className={styles.closeButton} aria-label="Close gallery" onClick={props.onCloseClick}>
            <img
              id="closeButton"
              src={`${ASSET_PREFIX}/images/close_button_white.svg`}
              alt=""
            />
          </button>
      </EmblaCarousel>
      </div>
      : null
  );

};

export default FullScreenImageGallery;